/**
 * 파일명: ceoMessage.js
 * 작성자: 김준형
 * 작성일자: 26.08.10
 * 설명: About Us - CEO 인사말
 */
import React from "react";
import useAboutBg from "components/about/aboutAsset";
import useDesignLines from "components/about/aboutLines";
import style from "css/about.module.css";

const CEO_PARAGRAPHS = [
  [
    "리브테크놀로지는 '리브(RIV)'라는 이름 속에 담긴 생동감과 혁신의 정신으로, ",
    "위기 속에서 늘 기회를 찾아왔고, 불가능해 보이던 목표를 현실로 증명해 왔습니다.",
  ],
  [
    "AX 대전환의 시대를 맞아 하이브리드 워킹을 기반으로 AI 기술을 내재화함으로써 ",
    "스마트 워크 플레이스를 선도해나갈 것입니다.",
  ],
  [
    "또한 자체 솔루션 개발을 통한 차별화된 가치 구현으로 Telehealth 시장의 신흥 강자로서 ",
    "원격진료 및 협진의 표준을 만들어갈 것입니다. ",
    "감사합니다.",
  ],
];

function CeoMessage() {
  const bg = useAboutBg();
  const lines = useDesignLines();

  return (
    <section
      className={style.ab_ceo}
      id="ceo"
    >
      <div className={style.ab_ceo_inner}>
        <div className={style.ab_ceo_badge_row}>
          <span className={style.ab_ceo_badge}>CEO 인사말</span>
          <span className={style.ab_ceo_badge_line} />
        </div>

        <h2 className={style.ab_ceo_title}>
          <strong>리브테크놀로지</strong>에
          <br />
          방문해 주신 것을 감사드립니다.
        </h2>

        <div className={style.ab_ceo_body}>
          {CEO_PARAGRAPHS.map((paragraph) => (
            <p key={paragraph[0]}>{lines(paragraph)}</p>
          ))}
        </div>

        <div className={style.ab_ceo_sign}>
          <span className={style.ab_ceo_sign_label}>
            (주)리브테크놀로지 대표이사
          </span>
          <span className={style.ab_ceo_sign_name}>김우성</span>
        </div>

        <div className={style.ab_ceo_photo_row}>
          <span
            className={style.ab_ceo_photo}
            style={bg("ceo_profile")}
          />
          <span
            className={style.ab_ceo_pattern}
            style={bg("ceo_pattern")}
          />
        </div>
      </div>
    </section>
  );
}

export default CeoMessage;
